import { createStyles, Theme } from '@material-ui/core';

import cancelIcon from '#web-components/assets/icons/cancel.svg';
import cancelHoverIcon from '#web-components/assets/icons/cancelBlack.svg';

import { COMPONENT_CLASSES } from '../../constants';

const BORDER_WIDTH = 2;

export const createButtonStyles = ({
  colors, typography, spacing, flags,
}: Theme) => ({
  '.formio-component-button:not(:has(button))': {
    display: 'none',
  },
  [`.${COMPONENT_CLASSES.buttonPrimaryComponent}, .${COMPONENT_CLASSES.buttonSecondaryComponent}`]: {
    '& .button-icon-right': {
      display: 'none',
    },
    '& .btn.btn:not(.editRow):not(.removeRow)': {
      ...typography.h6,
      boxShadow: 'none !important',
      border: 'none',
      textTransform: 'none',
      borderRadius: 40,
      borderColor: 'initial',
      '&:disabled': {
        opacity: 1,
        borderColor: 'initial',
      },
    },
    '& .btn.editRow, .btn.removeRow': {
      ...typography.textRegular,
      cursor: 'pointer',
      '&.btn-danger': {
        backgroundColor: 'rgba(0, 0, 0, 0)',
        borderColor: 'rgba(0, 0, 0, 0)',
      },
    },
  },
  [`div.${COMPONENT_CLASSES.buttonPrimaryComponent}`]: {
    '& .btn.btn:not(.editRow):not(.removeRow)': {
      padding: `${spacing(2)}px ${spacing(4)}px`,
      backgroundColor: `${colors.controls.button.primary.enabled.fill}!important`,
      color: colors.controls.button.primary.enabled.name,
      '&:hover:not([disabled])': {
        background: `${colors.controls.button.primary.hovered.fill} !important`,
        color: colors.controls.button.primary.hovered.name,
        transition: 'background-color 1000ms ease-in',
      },
      '&:disabled': {
        color: colors.controls.button.primary.disabled.name,
        backgroundColor: `${colors.controls.button.primary.disabled.fill} !important`,
      },
      '&:active:not([disabled])': {
        background: `${colors.controls.button.primary.pressed.fill} !important`,
        color: colors.controls.button.primary.pressed.name,
        transition: 'background-color 1000ms ease-in',
      },
    },
  },
  [`div.${COMPONENT_CLASSES.buttonSecondaryComponent}`]: {
    color: colors.controls.button.secondary.enabled.name,
    borderColor: colors.controls.button.secondary.enabled.stroke,
    backgroundOrigin: 'border-box',
    borderWidth: BORDER_WIDTH,
    width: 'fit-content',
    cursor: 'pointer',
    borderStyle: 'solid',
    borderRadius: spacing(5),
    '&:hover:not(.button-disabled):not(:active)': {
      color: colors.controls.button.secondary.hovered.name,
      borderColor: flags.boxStyle === 'full' ? colors.controls.button.secondary.hovered.stroke : 'transparent',
      backgroundImage: flags.boxStyle === 'stroke' ? colors.controls.button.secondary.hovered.stroke : 'none',
      borderWidth: BORDER_WIDTH,

      '& .btn.btn:not(.editRow):not(.removeRow)': {
        background: `${
          flags.boxStyle === 'full' ? colors.controls.button.secondary.hovered.fill : colors.layout.backgroundPrimary
        } !important`,
        padding: `${spacing(2) - BORDER_WIDTH}px ${spacing(4) - BORDER_WIDTH}px`,
        color: colors.controls.button.secondary.enabled.name,
      },
    },
    '&:active:not(.button-disabled)': {
      color: colors.controls.button.secondary.pressed.name,
      borderColor: colors.controls.button.secondary.pressed.stroke,
      '& .btn.btn:not(.editRow):not(.removeRow)': {
        background: `${
          flags.boxStyle === 'full' ? colors.controls.button.secondary.pressed.fill : colors.layout.backgroundPrimary
        } !important`,
        color: colors.controls.button.secondary.pressed.name,
      },
    },
    '&.button-disabled': {
      color: colors.controls.button.secondary.disabled.name,
      borderColor: colors.controls.button.secondary.disabled.stroke,
      '& .btn.btn:not(.editRow):not(.removeRow)': {
        color: colors.controls.button.secondary.disabled.name,
      },
    },
    '& .btn.btn:not(.editRow):not(.removeRow)': {
      padding: `${spacing(2) - BORDER_WIDTH}px ${spacing(4) - BORDER_WIDTH}px`,
      background: `${colors.layout.backgroundPrimary} !important`,
      color: colors.controls.button.secondary.enabled.name,
    },
  },
  [`div.${COMPONENT_CLASSES.buttonCancelComponent}`]: {
    width: 'fit-content',
  },
  [`.btn.${COMPONENT_CLASSES.buttonCancelComponent}`]: {
    ...typography.accentRegular,
    backgroundColor: `${colors.layout.backgroundPrimary} !important`,
    color: `${colors.controls.buttonText.enabled.name} !important`,
    border: 'none !important',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: spacing(4),
    padding: `${spacing(2)}px ${spacing(4)}px`,
    paddingLeft: spacing(8),

    '&:before': {
      content: `url(${cancelIcon})`,
      position: 'relative',
      top: 3,
      left: `-${spacing(6)}px`,
      width: 0,
      overflow: 'visible',
    },

    '&:hover:not([disabled])': {
      backgroundColor: `${colors.controls.buttonText.hovered.fill} !important`,
      color: `${colors.controls.buttonText.hovered.name} !important`,
      background: colors.controls.buttonText.hovered.fill,
      '&:before': {
        content: `url(${cancelHoverIcon})`,
      },
    },
    '&:active:not([disabled])': {
      backgroundColor: `${colors.controls.buttonText.pressed.fill} !important`,
      color: `${colors.controls.buttonText.pressed.name} !important`,
    },

    '&:focus': {
      boxShadow: 'none',
    },

    '& .button-icon-right': {
      display: 'none',
    },
  },
}) as Record<string, unknown>;

export default (theme: Theme) => createStyles({
  '@global': createButtonStyles(theme),
});
